import {Typography} from '@mui/material';
import ArrModal from '../../../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './GenerateArtifactsModal.scss';

interface GenerateArtifactsModalProps {
  open: boolean;
  onClose: () => void;
  handleGenerateArtifacts: () => void;
}
const GenerateArtifactsModal = ({
  open,
  onClose,
  handleGenerateArtifacts,
}: GenerateArtifactsModalProps) => {
  const handleConfirm = () => {
    handleGenerateArtifacts();
    onClose();
  };

  return (
    <>
      <ArrModal
        className="generateArtifactModal"
        showModal={open}
        onClose={onClose}
        showClose={false}
        title={t('ai.review.header.genArtifactModalTitle')}
        aria-label="gen-artifact-modal"
        dataTestId="arr-review-gen-artifact-modal"
        buttons={[
          {
            id: 'cancel-btn',
            label: t('ai.review.leftPanel.cancelBtn'),
            onClick: onClose,
            variant: 'secondary',
            dataTestId: 'gam-cancel-button',
            className: 'cancel-button',
          },
          {
            id: 'gen-artifacts-btn',
            label: t('ai.review.header.genArtifactModalTitle'),
            onClick: handleConfirm,
            variant: 'primary',
            dataTestId: 'gam-confirm-button',
            className: 'gen-artifacts-button',
          },
        ]}
      >
        <Typography
          className="generateArtifactModal-description"
          tabIndex={0}
          data-testid={`generate-artifacts-modal-gen-artifact-modal-desc`}
        >
          {t('ai.review.header.genArtifactModalDesc')}
          <ul
            className="list-items"
            tabIndex={0}
            data-testid={`generate-artifacts-modal-ul`}
          >
            {(
              t('ai.review.header.genArtifactModalBullets', {
                returnObjects: true,
              }) as string[]
            ).map((item: string, key: number) => (
              <li key={key} data-testid={`generate-artifacts-modal-li-${key}`}>
                {item}
              </li>
            ))}
          </ul>
        </Typography>
        <Typography
          className="generateArtifactModal-description"
          tabIndex={0}
          data-testid={`generate-artifacts-modal-gen-artifact-modal-footer`}
        >
          {t('ai.review.header.genArtifactModalFooter')}
        </Typography>
      </ArrModal>
    </>
  );
};

export default GenerateArtifactsModal;
